<template>
    <!-- Modal -->
  <vs-popup
    class="holamundo"
    title="Enrolled Courses"
    :active.sync="showCourseListModal"
  >
    <div
      style="max-height: 250px; overflow: auto"
      class="vertical_scrollbar horizontal_scrollbar"
      @scroll="detectsScrollLength()"
      ref="element"
      >
    <vs-table :data="courseLists" class="cstm_vuexy_table">
      <template slot="thead">
        <vs-th>Course Name</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            {{ data[indextr].name }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    </div>
  </vs-popup>
</template>

<script>
import { newcourseListing } from '@/api/course-builderapi'
export default {
  props:{
    showCourseListModal:{
      default:false
    },
    user_id:{
      default:null
    }
  },
  watch: {
    showCourseListModal () {
      if (!this.showCourseListModal) {
        this.$emit('CoursePopupClose', false)
      }
    }
  },
  data () {
    return {
      studentModalPopup:false,
      courseLists: [],
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      allsubjectsArray: [],
      students:[]
    }
  },
  mounted () {
    this.fetchCourseList()
  },
  methods: {
    async detectsScrollLength () {

      if (
        Math.ceil(
          this.$refs.element.scrollTop + this.$refs.element.offsetHeight
        ) >= this.$refs.element.scrollHeight  &&  this.meta.has_next
      ) {
        this.meta.current_page =  this.meta.current_page + 1
        this.loadMore()
      }
    },
    async loadMore () {
      try {
        this.$vs.loading({
          text: 'Please Wait  ...'
        })
        const payload = {}
        const customer_id = this.$store.getters.customerId
        payload.limit = 10
        payload.user_id = this.user_id
        const responeList = await newcourseListing(
          customer_id,

          payload,
          this.meta.current_page,
          {},
          'course_table'
        )

        this.courseLists.push(...responeList.data.data.course)
        this.meta = responeList.data.data.meta
      } catch (error) {
        //
        this.$vs.loading.close()

        console.log(error)
      } finally {
        this.$vs.loading.close()
      }
    },
    async fetchCourseList () {
      try {
        this.$vs.loading({
          text: 'Please Wait  ...'
        })
        const payload = {}
        const customer_id = this.$store.getters.customerId
        payload.limit = 10
        payload.user_id = this.user_id
        console.log(this.user_id)
        const responeList = await newcourseListing(
          customer_id,
          payload,
          this.meta.current_page,
          {},
          'course_table'
        )

        this.courseLists = responeList.data.data.course
        this.meta = responeList.data.data.meta
      } catch (error) {
        //
        this.$vs.loading.close()
        console.log(error)
      } finally {
        this.$vs.loading.close()
      }
    }
  }
}
</script>
